import * as z from "zod";

export const cin7OmniCreditNoteCustomFieldSchema = z.object({
  fieldKey: z.string().min(1, "Field name is required"),
  fieldValue: z.string().min(1, "Field value is required"),
});

export const cin7OmniReturnsSettingsSchema = z.object({
  apiUsername: z.string().optional(),
  apiKey: z.string().optional(),
  baseUrl: z.string().nullable().optional(),
  enabled: z.boolean().optional(),
  createReturnsEnabled: z.boolean().optional(),
  processReturnsEnabled: z.boolean().optional(),
  returnTypeCustomFieldKey: z.string().nullable().optional(),
  compensationMethodCustomFieldKey: z.string().nullable().optional(),
  creditNoteCustomFields: z
    .array(cin7OmniCreditNoteCustomFieldSchema)
    .optional(),
});

export const updateCin7OmniReturnsSettings = {
  name: "updateCin7OmniReturnsSettings" as const,
  input: cin7OmniReturnsSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
